/** Every spreadsheet import the universal "Import" dialog can route a file to. */
export const importKindLabels = {
    customers: 'Customers',
    teamMembers: 'Team members',
    services: 'Services',
    products: 'Products',
    membershipPlans: 'Membership plans',
    offers: 'Promotions',
    resources: 'Rooms & equipment',
    shifts: 'Shifts',
    calendar: 'Calendar',
};
export const importKindValues = Object.keys(importKindLabels);
/**
 * Every kind of row an import can create. An admin import records the ids it
 * created under these keys so the whole import can be wiped later (ENG-1325).
 */
export const importedRecordTypeLabels = {
    appointments: 'Bookings',
    blockedTimes: 'Blocked times',
    shifts: 'Shifts',
    offers: 'Promotions',
    membershipPlans: 'Membership plans',
    customers: 'Customers',
    products: 'Products',
    productBrands: 'Product brands',
    productCategories: 'Product categories',
    serviceVariants: 'Service options',
    serviceStaff: 'Service team assignments',
    services: 'Services',
    serviceCategories: 'Service categories',
    resources: 'Rooms & equipment',
    resourceCategories: 'Room & equipment categories',
    teamMembers: 'Team members',
};
/** In wipe order: records that point at others come before what they point at. */
export const importedRecordTypeValues = Object.keys(importedRecordTypeLabels);
//# sourceMappingURL=imports.js.map